<template>
    <div class="md:w-[400px] 2xl:w-[465px] sm:w-[300] border-r px-5 my-1 "
         :class="$widgetUI=='NEW-UI' && activemoble ? 'px-3 py-2 filter-sidebar top80': $widgetUI=='NEW-UI' && !activemoble ? 'px-3 py-2 filter-sidebar top40':''"
         v-if="$widgetUI=='NEW-UI' && showfilter">

        <div class=" w-full  relative" :class="$widgetUI=='OLD-UI' ? 'bg-primary w-full p-[10px] 2xl:p-[20px] relative':''">
            <div class="flex justify-between">
                <div class="text-black-50 text-[18px]  font-bold py-3" v-if="$widgetUI=='NEW-UI'">
                    Choose filters
                    <help-tip
                        content='Build a targeted list using the filters below.'
                        class="ml-2"
                    />
                </div>
                <div class="flex">
                    <!--                    <button type="button" class="group btn bg-fully border-1 text-white bg-primary lg:hidden" @click="applyFilter()"> Apply</button>-->

                    <div @click="toggleShowMenu" class="closebtn cursor-pointer w-[46px] h-[46px] flex items-center justify-center -mr-4 group ">
                        <svg width="17"
                             height="17"
                             viewBox="0 0 17 17"
                             fill="none"
                             class="stroke-2 stroke-primary group-hover:stroke-primary"
                             style="z-index: 999;"
                             x-cloak>
                            <path d="M2 2L15 15M15 2L2 15"/>
                        </svg>
                    </div>

                </div>
            </div>


            <div id="accordion-collapse" data-accordion="collapse" class="bg-white py-2 px-4" v-if="$widgetUI=='NEW-UI' && checkLocalstorage">
                <h2 id="accordion-collapse-heading-1">
                    <button type="button" class="flex items-center justify-between w-full text-[14px]" data-accordion-target="#accordion-collapse-body-1" aria-expanded="true" aria-controls="accordion-collapse-body-1" @click="accordion= !accordion">
                        <span>Filters on your last visit :</span>
                        <svg data-accordion-icon class="w-3 h-3 rotate-180 shrink-0" :class="accordion ? 'rotate-180': 'rotate-90'"  aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
                        </svg>
                    </button>
                </h2>
                <div id="accordion-collapse-body-1 " :class="accordion ? 'block': 'hidden'" aria-labelledby="accordion-collapse-heading-1">
                    <select-from-storage v-if="checkLocalstorage"/>
                </div>
            </div>

        </div>

        <div class="tabs w-full my-3" data-tabs>
            <template v-for="tab in tabs">
                <div :key="tab.key"
                     class="tab-item"
                     :class="[{'active': activeTab.key === tab.key}, {'complete': tab.index < activeTab.index}]"
                     @click="setTab(tab)">
                    {{ tab.title }}
                </div>
            </template>
        </div>

        <div class="overflow-y-auto p-2 2xl:p-4 w-full h-full">
            <contact-info v-show="activeTab.key === 'contact_info'"/>
            <geography v-show="activeTab.key === 'geography'" :with-step="false"/>
            <selections v-show="activeTab.key === 'selections'"/>
        </div>
    </div>
</template>

<script>
import { EventBus } from "@widget/plugins/event-bus";
import geography from "./geography";
import selections from "./selections";
import confirmationTooltip from "./confirmation-tooltip";
import ContactInfo from "./contact-info";
import AudienceStaticAudience from "./audience-static-audience";
import selectFromStorage from "./select-from-storage";
import dayjs from "dayjs";
import xPerSelectionMixin from "../mixins/xPerSelection";


export default {
    name: "choose-filter",
    components: {
        AudienceStaticAudience,
        ContactInfo,
        geography,
        selections,
        confirmationTooltip,
        selectFromStorage
    },
    mixins: [
        xPerSelectionMixin
    ],
    computed: {
        showfilter() {
            return this.$store.state.widgetData.showfilter;
        },
        activemoble(){
            return window.activemoble;
        },
        audience () {
            return this.$store.getters["widgetData/selectedData"].audience;
        },
        changeTabButtonText () {
            return this.tabs[this.activeTab.index].title;
        },
        confirmationTooltip () {
            return this.$store.getters["others/getConfirmationTooltip"];
        },
        tabs () {
            let textStepSelection = this.$store.getters["widgetData/selectedData"].audience === this.$widgetConfig.b2cBase ? "Demographics" : "Firmographics";

            /* if (this.$widgetConfig.contactInfo3rd) {
                 return [
                     {
                         index: 1,
                         title: "Geography",
                         key: "geography"
                     },
                     {
                         index: 2,
                         title: textStepSelection,
                         key: "selections"
                     },
                     {
                         index: 3,
                         title: "Contact Info",
                         key: "contact_info"
                     }
                 ];
             }*/

            return [

                {
                    index: 1,
                    title: "Geography",
                    key: "geography"
                },
                {
                    index: 2,
                    title: textStepSelection,
                    key: "selections"
                },
                {
                    index: 3,
                    title: "Contact Info",
                    key: "contact_info"
                }
            ];
        },
        showBackBtn () {
            return this.activeTab.index > 1;
        },
        showNextBtn () {
            return this.activeTab.index < 3;
        },
        checkLocalstorage () {
            let storage = JSON.parse(localStorage.getItem("widget-store"));
            if (storage) {
                let a = dayjs(storage.expireDate);
                let b = dayjs(Date.now());
                if (a.diff(b, "days") < 10) {
                    return true;
                } else {
                    localStorage.removeItem("widget-store");
                    return false;
                }
            }
            return false;
        }
    },
    watch: {
        audience () {
            this.activeTab = this.tabs[0];
        }
    },
    methods: {
        toggleShowMenu(){
            this.$store.state.widgetData.showfilter = false;
            // this.$store.commit("widgetData/clearAll");
            // EventBus.$emit("clear-all");
            // this.checkXPerSelection();

        },
        applyFilter() {
            this.$store.state.widgetData.showfilter = false;
        },
        focusLead () {
            this.$scrollTo("body", 500, { offset: 0 });
            EventBus.$emit("focus-input-lead");
        },
        setTab (payload) {
            this.activeTab = payload;
        },
        nextTab () {
            let currentIndex = this.tabs.findIndex(item => item.key === this.activeTab.key);
            if (currentIndex !== -1) {
                this.activeTab = this.tabs[currentIndex + 1];
            }
        },
        backTab () {
            let currentIndex = this.tabs.findIndex(item => item.key === this.activeTab.key);
            if (currentIndex !== -1) {
                this.activeTab = this.tabs[currentIndex - 1];
            }
        }
    },
    data () {
        return {
            activeTab: null  ,
            accordion: true,

        };
    },
    created () {
        let treatment = this.$store.getters["others/getTreatment"]("toggle_firmographics");
        this.activeTab = treatment && treatment === "on" ? this.tabs.find(item => item.key === "selections") : this.tabs[0];
    },
    mounted () {
        EventBus.$on("edit-select", () => {
            this.activeTab = this.tabs.find(item => item.key === "selections");
        });

        EventBus.$on("show-select-position", (select) => {
            if (select.code) {
                let geoTab = select.code.includes("_geo_search") || select.code.includes("_zip_radius") || select.code.includes("_mapping");

                if (geoTab) {
                    this.activeTab = this.tabs.find(item => item.key === "geography");
                } else if (select.code.includes("_one_per_address")) {
                    this.activeTab = this.tabs.find(item => item.key === "contact_info");
                } else {
                    this.activeTab = this.tabs.find(item => item.key === "selections");
                }
            } else if (select === "sub-audience") {
                this.activeTab = this.tabs.find(item => item.key === "contact_info");
            } else if (select === "geography") {
                this.activeTab = this.tabs.find(item => item.key === "geography");
            }
        });
    }
};
</script>

<style lang="scss" scoped>
.mobileview{
    display:none;
}
.bg-primary-100{
    background: #EDF3FF;
    padding: 15px 8px;
}
.gap-16{
    gap:18px
}
.btn-tour{
    background: #FBEBD4;
    border-radius: 6px;
    border: 1px solid #B1B1B1

}
</style>
